import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { spaceM } = theme();

  return StyleSheet.create({
    button: {
      marginTop: spaceM,
    },
  });
};

export { style };
